import axios from "./axios";
import DataModel from "./data-model";

export * from "./axios";
export * from "./data-model";
export * from "./hooks";
export * from "./type";

export { axios, DataModel };

export default DataModel;
